__turbopack_context__.v({
  "btn": "CheckoutConfirmPopup-module-scss-module__g49hFG__btn",
  "btnContinue": "CheckoutConfirmPopup-module-scss-module__g49hFG__btnContinue",
  "btnGoBack": "CheckoutConfirmPopup-module-scss-module__g49hFG__btnGoBack",
  "footer": "CheckoutConfirmPopup-module-scss-module__g49hFG__footer",
  "root": "CheckoutConfirmPopup-module-scss-module__g49hFG__root",
});
